import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getControlFull } from '../Api'

export default generateApiAction({
  baseType: Types.CONTROLS.GET.FULL,
  api: getControlFull,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/controls/GetFullAction.js